import React, {useEffect, useRef, useState} from "react";
import styled, {css} from "styled-components";
import {BaseModal} from "../../../modal/modalStyle";
import ExitButton from "../../../buttons/ExitButton";
import {useDispatch, useSelector} from "react-redux";
import {loadUsers} from "../../../user/usersAction";
import SendFormButton from "../../../buttons/SendFormButton";
import {useLocation, useNavigate} from "react-router-dom";
import {loadAllAxis} from "../../../axis/all-axis/axisAction";
import TagInput from "../../../inputs/TagInput";
import {loadAllTagCategories} from "../../../tag/tagCategory/tagCategoryAction";
import {loadStakes} from "../../../stake/actions/stakeAction";
import {HOME_ROUTE, STRATEGY_ABSOLUTE_ROUTE,} from "../../../../routes/routesName";
import useSortItems from "../../../../custom-hooks/useSortItems";
import {deleteOneProject, loadProject, patchProject} from "../projectAction";
import {loadOneAxis} from "../../../axis/one-axis/oneAxisAction";
import {loadProjects} from "../../projects/projectsAction";
import {CLEAR_STAKES} from "../../../stake/actions/actionTypes";
import useTags from "../../../../custom-hooks/useTags";
import {ErrorMessage, Field, Formik} from "formik";
import {FormFormik, InputTextFormik} from "../../../inputs/InputStyle";
import SelectAxisInputFormik from "../../../inputs/SelectAxisInputFormik";
import SelectStakeInputFormik from "../../../inputs/SelectStakeInputFormik";
import SelectUserInputFormik from "../../../inputs/SelectUserInputFormik";
import SelectWeatherInputFormik from "../../../inputs/SelectWeatherInputFormik";
import InputAdvancementFormik from "../../../inputs/InputAdvancementFormik";
import CounterInputFormik from "../../../inputs/CounterInputFormik";
import CheckboxFormikInput from "../../../inputs/CheckboxFormikInput";
import SelectUsersFormikInput from "../../../inputs/SelectUsersFormikInput";
import * as Yup from "yup";
import TextareaFormikInput from "../../../inputs/TextareaFormikInput";
import SearchBarUserName from "../../../search-bar/SearchBarUserName";
import useFilterUser from "../../../../custom-hooks/useFilterUser";
import {CLEAR_PROJECT} from "../../actionsType";
import YesNoModal from "../../../modal/YesNoModal";

const UpdateProject = ({ setIsOpenUpdateProject, projectId = 0 }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return function cleanup() {
      document.body.style.overflow = "auto";
    };
  }, []);

  const { returnRemovedItems, returnAddedItems, pushItemsInArray } =
    useSortItems();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  const { id: axisId } = useSelector((state) => state.oneAxis);
  const { users } = useSelector((state) => state.users);
  const { stakes } = useSelector((state) => state.stakes);
  const { axis } = useSelector((state) => state.axis);
  const { projects } = useSelector((state) => state.projects);
  const {
    id,
    name,
    referenceCode,
    comment,
    pilot,
    copilot,
    members,
    advancement,
    weather,
    stake,
    tags,
    estimatedInvestmentBudget,
    estimatedExploitationBudget,
    estimatedTimeSpent,
    startDate,
    endDate,
    isConfidential,
    isTimeSpentOptional,
    isBudgetOptional,
  } = useSelector((state) => state.project);

  const { selectedTags, setSelectedTags } = useTags([], tags);

  const [stateUserContainer, setStateUserContainer] = useState({
    pilot: true,
    copilot: false,
    members: false,
  });
  const [stakeError, setStakeError] = useState(false);

  const handleUsersContainerDisplay = (el) => {
    const data = Object.assign({}, stateUserContainer);
    for (let key in stateUserContainer) {
      data[key] = key === el;
    }
    setStateUserContainer(data);
  };

  const location = useLocation();
  const { id: currentUserId, status } = useSelector((state) => state.currentUser);
  useEffect(() => {
    // waiting that the current user is fetched to load projects (asynchronous to handle refresh token)
    dispatch(loadUsers());
    dispatch(loadAllTagCategories());
    if(projectId){
      dispatch(loadProject(projectId));
    }
  }, [dispatch]);

  useEffect(() => {
    if (location.pathname === HOME_ROUTE) {
      dispatch(loadAllAxis());
      dispatch(loadStakes());
    }
    if (location.pathname === STRATEGY_ABSOLUTE_ROUTE) {
      dispatch(loadStakes());
    }
    if(projectId){
      dispatch(loadProject(projectId));
    }
  }, [dispatch, location.pathname]);

  useEffect(() => {
    return () => {
      //dispatch({ type: CLEAR_PROJECT });
      dispatch({ type: CLEAR_STAKES });
      setIsOpenUpdateProject(false);
    };
  }, [dispatch, location.pathname, setIsOpenUpdateProject]);

  const close = () => {
    setIsOpenUpdateProject(false);
  };
  const deleteRequest = async (project_id) => {
    if (status === 200) {
      await dispatch(deleteOneProject(project_id))
      setIsOpenDeleteModal(false);
      //dispatch({type: CLEAR_PROJECT})
      if (status === 200) {
        navigate(`/`);
      }
      await dispatch(loadProjects(currentUserId))
    }
  }
  const handleDelete = () => {
    setIsOpenDeleteModal(!isOpenDeleteModal)
  }
  const handleSubmit = async (data) => {
    const newData = Object.assign({}, data);
    newData.pilotId = Number(newData.pilotId);
    // Check if copilot exist
    if (newData.hasCopilot) {
      newData.coPilotId = Number(data.coPilotId);
    } else {
      newData.coPilotId = null;
    }
    delete newData.hasCopilot;

    // MEMBERS
    let allMembers = [];
    newData.members.forEach((m) => {
      allMembers.push(Number(m));
    });
    const initialMembersId = members.map((m) => m.id);
    let removedMembers = initialMembersId.filter(
      (x) => !allMembers.includes(x)
    );
    let addedMembers = allMembers.filter((x) => !initialMembersId.includes(x));
    const keyName = "memberId";
    if (addedMembers.length > 0) {
      let membersArray = [];
      addedMembers.forEach((u) => {
        membersArray.push({ id: u });
      });
      newData.members = pushItemsInArray(membersArray, keyName);
    } else {
      delete newData.members;
    }

    if (removedMembers.length > 0) {
      let membersArray = [];
      removedMembers.forEach((u) => {
        membersArray.push({ id: u });
      });
      newData.removeMembers = pushItemsInArray(membersArray, keyName);
    }
    if (addedMembers.length === 0 && removedMembers.length === 0) {
      delete newData.members;
    }

    newData.confidential = newData.isConfidential;
    delete newData.isConfidential;
    newData.stakeId = Number(newData.stakeId);
    newData.isTimeSpentOptional = !newData.isTimeSpentOptional;
    newData.isBudgetOptional = !newData.isBudgetOptional;

    /// TAGS
    let removedTags = returnRemovedItems(selectedTags, tags, "tagId");
    let addedTags = returnAddedItems(selectedTags, tags, "tagId");
    if (removedTags) {
      newData.removeTags = removedTags;
    }
    if (addedTags) {
      newData.tags = addedTags;
    }

    // CHECK IF LINKED TO AXIS
    if (newData.linkedToAxis === false) {
      delete newData.axisId;
      newData.stakeId = null;
    } else {
      // Check if stake is in axis
      const axisSelected = axis.filter(
        (a) => a.id === Number(newData.axisId)
      )[0];
      let isStakeSelectedInAxisSelected = axisSelected?.stakes.filter(
        (a) => a.id === newData.stakeId
      );
      if (isStakeSelectedInAxisSelected.length === 0) {
        setStakeError(true);
        return;
      }
    }
    delete newData.linkedToAxis;
    delete newData.axisId;
    await dispatch(patchProject(id, newData));
    if (location.pathname === STRATEGY_ABSOLUTE_ROUTE) {
      await dispatch(loadOneAxis(axisId));
    } else {
      await dispatch(loadProjects(currentUserId));
    }
    setIsOpenUpdateProject(false);
  };

  const exitDetailHandler = (e) => {
    const element = e.target;
    if (element.classList.contains("shadow")) {
      close();
    }
  };

  const ProjectSchema = Yup.object().shape({
    isConfidential: Yup.bool(),
    name: Yup.string()
      .min(2, "Le nom de l'axe est trop court")
      .max(255, "Le nom de l'axe est trop long")
      .required("Le nom de l'axe est requis"),
    //referenceCode: Yup.string(),
    comment: Yup.string()
      .min(2, "Le commentaire doit avoir au moins 2 caractères")
      .max(1000, "Le commentaire ne doit pas dépasser 1000 caractères"),
    endDate: Yup.string(),
    startDate: Yup.string(),
    estimatedInvestmentBudget: Yup.number(),
    estimatedExploitationBudget: Yup.number(),
    estimatedTimeSpent: Yup.number(),
    isTimeSpentOptional: Yup.bool(),
    isBudgetOptional: Yup.bool(),
    pilotId: Yup.string().required("Il est obligatoire de choisir un pilote"),
    copilotId: Yup.string(),
    advancement: Yup.number(),
    weather: Yup.string().oneOf(["sunny", "cloudy", "stormy", "rainy"]),
  });
  const { query, setQuery } = useFilterUser(projects);

  const formikRef = useRef(null);
  return (
    <div className={"shadow"} onClick={exitDetailHandler}>
      <Modal>
        <FirstSection>
          <Title>
            <SendFormButton
                actionName={"Enregistrer"}
                state={formikRef.current?.isValid && !formikRef.current?.isSubmitting}
                action={() => formikRef.current.submitForm()}
            />
          </Title>
          <ExitButton closeUpdate={close} />
        </FirstSection>
        {
          isOpenDeleteModal &&
            <YesNoModal
                name={"ce projet (vous pouvez le retrouver dans les archives) ?"}
                setOpenModal={setIsOpenDeleteModal}
                handleClickYesAction={deleteRequest}
                id={id}
            />
        }
        <Formik
          enableReinitialize
          innerRef={formikRef}
          initialValues={{
            isConfidential: isConfidential,
            name: name,
            referenceCode: referenceCode ? referenceCode : "",
            pilotId: pilot.id?.toString(),
            coPilotId: copilot ? copilot.id?.toString() : "",
            hasCopilot: !!copilot,
            members: members ? members.map((m) => m.id.toString()) : [],
            comment: comment ? comment : "",
            axisId: stake?.axisId ? stake?.axisId : "",
            linkedToAxis: !!stake,
            stakeId: stake ? stake.id?.toString() : "",
            startDate: startDate ? startDate : "",
            endDate: endDate ? endDate : "",
            isTimeSpentOptional: !isTimeSpentOptional,
            estimatedTimeSpent: estimatedTimeSpent,
            isBudgetOptional: !isBudgetOptional,
            estimatedInvestmentBudget: estimatedInvestmentBudget,
            estimatedExploitationBudget: estimatedExploitationBudget,
            advancement: advancement,
            weather: weather ? weather : "",
          }}
          validationSchema={ProjectSchema}
          onSubmit={handleSubmit}
        >
          {({ isValid, isSubmitting, values }) => (
            <Form>
              <First>
                <DIV>
                  <Name>
                    <label htmlFor="name"> Nom </label>
                    <InputTextFormik
                      type="text"
                      name={"name"}
                      placeholder={"Votre nom de projet"}
                    />
                    <ErrorMessage
                      name="name"
                      render={(msg) => (
                        <div>
                          <p className="error-text"> {msg} </p>
                        </div>
                      )}
                    />
                  </Name>
                  <Reference>
                    <label htmlFor="referenceCode">Référence du projet</label>
                    <Ref name="referenceCode" placeholder={referenceCode} />
                  </Reference>
                </DIV>

                <Comment>
                  <label htmlFor="comment"> Commentaires </label>
                  <TextareaFormikInput
                    name="comment"
                    rows="5"
                    placeholder="Pourquoi ce projet ? (problème de départ, améliorations attendues, population ciblée, retour sur investissement attendu,…)"
                  />
                </Comment>
              </First>

              <StrategyContainer>
                <StrategyFirstSection>
                  <StrategySeparator>
                    <p> Stratégie </p>
                  </StrategySeparator>
                  <CheckboxFormikInput
                    label={"Avec axe"}
                    name={"linkedToAxis"}
                  />
                </StrategyFirstSection>
                <Second>
                  {values.linkedToAxis && (
                    <>
                      <SelectAxisInputFormik
                        initialAxisId={stake ? stake.axisId : 0}
                        axisId={values.axisId}
                      />
                      <SelectStakeInputFormik
                        initialStake={stake ? stake.stakeId : 0}
                        stakeId={values.stakeId}
                        stakeSelected={stakes.filter(
                          (s) => s.axisId === Number(values.axisId)
                        )}
                        limitedItems={true}
                      />
                      <ErrorMessage
                        name="stake"
                        render={(msg) => (
                          <div>
                            <p className="error-text"> {msg} </p>
                          </div>
                        )}
                      />
                      {stakeError && (
                        <p className={"error-text"}>
                          {" "}
                          L'enjeu n'est pas sélectionné ou ne correspond pas à
                          l'axe choisi{" "}
                        </p>
                      )}
                    </>
                  )}
                </Second>
              </StrategyContainer>

              <Grid>
                <Date>
                  <label htmlFor="startDate"> Date de démarrage</label>
                  <Field name={"startDate"} type={"date"} />
                </Date>
                <Date>
                  <label htmlFor="endDate"> Date de fin</label>
                  <Field name={"endDate"} type={"date"} />
                </Date>
                <Advancement>
                  <label> Avancement </label>
                  <InputAdvancementFormik
                    advancementSelection={values.advancement}
                  />
                </Advancement>
              </Grid>
              <GridS>
                <Weather>
                  <label> Météo </label>
                  <SelectWeatherInputFormik value={values.weather} />
                </Weather>

                <Counter>
                  <CheckboxFormikInput
                    name={"isBudgetOptional"}
                    label={"Avec budget"}
                  />
                  {values.isBudgetOptional && (
                    <>
                      <>
                        <label>Budget prévisionnel d'investissement (en euros)</label>
                        <CounterInputFormik name={"estimatedInvestmentBudget"} step={50} />
                      </>
                      <>
                        <label>Budget prévisionnel d'exploitation (en euros)</label>
                        <CounterInputFormik name={"estimatedExploitationBudget"} step={50} />
                      </>
                    </>
                  )}
                  {!values.isBudgetOptional && (
                    <p>Ce projet n'a pas de budget défini</p>
                  )}
                </Counter>
                <Counter>
                  <CheckboxFormikInput
                    name={"isTimeSpentOptional"}
                    label={"Avec temps prévisionnel"}
                  />
                  {values.isTimeSpentOptional && (
                    <>
                      <label>Temps prévisionnel (en heures)</label>
                      <CounterInputFormik
                        name={"estimatedTimeSpent"}
                        step={1}
                      />
                    </>
                  )}
                  {!values.isTimeSpentOptional && (
                    <p>Ce projet n'a pas de temps passé défini</p>
                  )}
                </Counter>
              </GridS>

              <Container>
                <label> Sélectionner les membres du projet : </label>
                <UsersGrid>
                  <Buttons>
                    <Button
                      $mode={stateUserContainer.pilot}
                      onClick={() => handleUsersContainerDisplay("pilot")}
                    >
                      <p>Pilote</p>
                    </Button>
                    <Button
                      $mode={stateUserContainer.copilot}
                      onClick={() => handleUsersContainerDisplay("copilot")}
                    >
                      <p>Copilote</p>
                    </Button>
                    <Button
                      $mode={stateUserContainer.members}
                      onClick={() => handleUsersContainerDisplay("members")}
                    >
                      <p>Membres</p>
                    </Button>
                  </Buttons>
                  <Users>
                    {stateUserContainer.pilot && (
                      <SelectUserInputFormik
                        users={users}
                        pilotId={values.pilotId}
                        displayLabel={false}
                        initialUser={pilot}
                      />
                    )}
                    {stateUserContainer.copilot && (
                      <Copilot>
                        <CheckboxFormikInput
                          label={"Avec copilote"}
                          name={"hasCopilot"}
                        />
                        {values.hasCopilot && (
                          <SelectUserInputFormik
                            users={users}
                            pilotId={values.coPilotId}
                            name={"coPilotId"}
                            label={"copilote"}
                            displayLabel={false}
                            initialUser={copilot}
                          />
                        )}
                      </Copilot>
                    )}
                    {stateUserContainer.members && (
                      <SelectUsersFormikInput
                        values={values.members}
                        users={users}
                        members={members}
                        initialUsers={members}
                      />
                    )}
                  </Users>
                  <ErrorMessage
                    name="pilotId"
                    render={(msg) => (
                      <div>
                        <p className="error-text"> {msg} </p>
                      </div>
                    )}
                  />
                </UsersGrid>
              </Container>
              <TagInput
                selectedTags={selectedTags}
                setSelectedTags={setSelectedTags}
              />
              <CheckboxFormikInput
                label={"Projet confidentiel"}
                name={"isConfidential"}
              />
            </Form>
          )}
        </Formik>
        <DeleteProjectButton
            onClick={handleDelete}
        >
          Archiver le projet
        </DeleteProjectButton>
      </Modal>
    </div>
  );
};
const Modal = styled(BaseModal)`
  height: fit-content;
  width: 100vw;
  cursor: initial;
  gap: 1em;
  inset: unset;

  label {
    font-weight: 700;
  }

  @media (min-width: 768px) {
    inset: 0;
    width: 80%;
    margin: 2em auto 3em auto;
  }
  @media (min-width: 1224px) {
    width: 1000px;
  }
`;

const Copilot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const UsersGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  @media (min-width: 900px) {
    display: grid;
    gap: 1em;
    grid-template-columns: 10rem 1fr;
  }
`;
const Title = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  h1 {
    flex-grow: 1;
    text-align: center;
  }

  h2 {
    margin-top: 1rem;
    text-align: center;
    background-color: var(--color-purple-lighten);
    z-index: 1000;

    border-radius: 5px;
    padding: 1rem;
  }
`;
const FirstSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: sticky;
  top: 0;
  background-color: #fff;
  border-radius: 15px;
  padding: 0 0 0 1rem; 
  opacity: 1;
  z-index: 5;

  .exit-btn {
    align-self: flex-start;
  }
`;

const Form = styled(FormFormik)`
  display: flex;
  flex-direction: column;
  gap: 1em;
`;
const First = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  width: 100%;
`;
const Comment = styled.div`
  width: 60%;
  padding-top: 5px;
`;

const DIV = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 40%;
`;
const Name = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
const Reference = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`;
const Ref = styled(Field)`
  border-radius: 10px;
  border: 1px solid var(--color-purple-lighten);
  padding: 0.5rem;
`;

const Second = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 1.5rem;
`;

const StrategyContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid var(--color-purple-lighten);
  padding: 1rem;
  gap: 1.5rem;
  width: 100%;
`;

const StrategyFirstSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;
const StrategySeparator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  p {
    font-size: 20px;
  }
`;

const Grid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1em;
  width: 100%;

  @media (min-width: 900px) {
    display: grid;
    gap: 1em;
    grid-template-columns: 1fr 1fr 3fr;
  }
`;
const Date = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  border-radius: 10px;
  border: 1px solid var(--color-purple-lighten);
  padding: 0.5rem;
`;
const Advancement = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 1px solid var(--color-purple-lighten);

`;

const GridS = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1em;
  width: 100%;

  @media (min-width: 900px) {
    display: grid;
    gap: 1em;
    grid-template-columns: 2.3fr 1.6fr 1.6fr;
  }
`;
const Weather = styled.div`
  border-radius: 10px;
  border: 1px solid var(--color-purple-lighten);
  padding-top: 0.5rem;

  label {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const Counter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  border-radius: 10px;
  border: 1px solid var(--color-purple-lighten);
  padding: 1rem;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;

  label {
    text-align: center;
    width: 100%;
  }
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
`;

const Button = styled.div`
  display: flex;
  justify-content: center;
  border: none;
  padding: 0.5rem 0;
  border-radius: 5px;
  cursor: pointer;
  background: transparent;
  box-shadow: 0 1px 2px rgb(0 0 0 / 8%), 0 4px 12px rgb(0 0 0 / 5%);

  p {
    font-size: 12px;
  }

  &:hover {
    background: var(--color-purple-lighten);
  }

  ${(props) => {
    switch (props.$mode) {
      case true:
        return css`
          background-color: var(--color-purple-lighten);
        `;
      default:
        return css``;
    }
  }}
}

`;
const Users = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow-x: scroll;
  padding: 0.5em;
  border-radius: 10px;
  gap: 1em;
  width: 100%;

  label {
    align-self: center;
  }
`;
const Wrapper = styled.div`
  height: 200px;
  overflow-y: auto;
`;

const Projects = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`;
const Project = styled.div`
  border: 1px solid var(--color-purple-lighten);
  padding: 0.5rem 1rem;
  border-radius: 10px;
  cursor: pointer;

  p {
    font-weight: 500;
  }

  :hover {
    background: var(--color-purple-06);

    p {
      color: var(--color-white);
    }
  }
`;

const InputContainer = styled.div`
  overflow: hidden;

  label > input {
    opacity: 0;
    display: none;
  }

  label > input:checked + div {
    background-color: var(--color-purple-06);

    p {
      color: var(--color-white);
    }
  }
`;


const DeleteProjectButton = styled.button`
  padding: 0.5rem;
  border: none;
  background-color: var(--color-red);
  color: white;
  border-radius: 10px;
  cursor: pointer;
  margin-left: 0.5rem;
  width: 20%;
  align-self: center;
`

export default UpdateProject;
